import { render, staticRenderFns } from "./Expedicao.vue?vue&type=template&id=63825cd4&scoped=true"
import script from "./Expedicao.vue?vue&type=script&lang=js"
export * from "./Expedicao.vue?vue&type=script&lang=js"
import style0 from "./Expedicao.vue?vue&type=style&index=0&id=63825cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63825cd4",
  null
  
)

export default component.exports